import { useEffect, useState } from 'react';

/**
 * One-time tips on this device (1.28: "Lange drücken zum Bearbeiten"). Gone once the person used
 * what the tip explains or closed it – a tip that keeps coming back is noise.
 */
export type Tip = 'jobEdit' | 'familyMode';

const key = (tip: Tip) => `shh.tip.${tip}`;
const CHANGED = 'shh:tip';

export function tipSeen(tip: Tip): boolean {
  try {
    return localStorage.getItem(key(tip)) === 'seen';
  } catch {
    return false;
  }
}

export function markTipSeen(tip: Tip) {
  try {
    localStorage.setItem(key(tip), 'seen');
  } catch {
    // private mode: the tip comes back next visit
  }
  window.dispatchEvent(new Event(CHANGED));
}

/** Whether the tip should still show; updates when it is used anywhere in the app. */
export function useTip(tip: Tip) {
  const [seen, setSeen] = useState(() => tipSeen(tip));
  useEffect(() => {
    const update = () => setSeen(tipSeen(tip));
    window.addEventListener(CHANGED, update);
    return () => window.removeEventListener(CHANGED, update);
  }, [tip]);
  return { show: !seen, dismiss: () => markTipSeen(tip) };
}
